module.exports = __webpack_public_path__ + "img/0Q3B3332_P_T_L_WoodMatted.81980cbd.jpg";